<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
    :content-style="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
    size="table"
  >
    <template #header>操作日志</template>
    <template #content>
      <app-base-main parentTable no-padding>
        <template #filter-group>
          <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery" :isBr="false">
              <gj-radio-group
                  v-model="filter.opType"
                  :options="[
                        {id: null, text: '全部'},
                        {id: 'Add', text: '新增'},
                        {id: 'Update', text: '编辑'},
                      ]">
              </gj-radio-group>
              <gj-input
                    v-model="filter.ruleName"
                    width="220px"
                    suffix-icon="el-icon-search"
                    placeholder="规则名称"
                  >
                  </gj-input>
              <gj-charger-select
                    v-model="filter.userIdList"
                    collapse-tags
                    placeholder="操作用户"
                    active
                  >
                  </gj-charger-select>
                    <gj-date-picker
                    v-model="filter.createDate"
                    type="daterange"
                ></gj-date-picker>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
             ref="gjTable"
             :columns="columns"
              adaptParent
              :data="data"
              :offset-to="'parent'"
              :offset-height="21"
              :loading="loading"
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery"
              :height="440"
          >
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn, queryMixin} from "@/minxins";
    import {getSendRuleLog} from "@/api/crm";
    import {convertToDate} from "@/utils/date.util";

    export default {
        name: "send-rule-log",
        mixins: [modalMixIn, queryMixin],
        props: {
          id: null,
        },
        data() {
          return {
              columns: [
                  {id: 'ruleName', header: '规则名称', field: 'ruleName', minWidth: '150px', overflowLine: 2, default: true},
                  {id: 'op', header: '操作类型', field: 'op', minWidth: '100px', default: true},
                  {id: 'content', header: '操作详情', field: 'content', minWidth: '250px', overflowLine: 2, default: true},
                  {id: 'createUser', header: '操作用户', field: 'userName', minWidth: '100px', default: true},
                  {id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '150px', default: true},
              ],
              data: [],
              filter: {
                opType: null,
                ruleName: null,
                userIdList: [],
                createDate: null,
              }

          }
        },
        methods: {
            $gjQueryInitParams() {
            return {
              filter: {
                opType: null,
                ruleName: null,
                userIdList: [],
                createDate: null,
              },
            }
          },
           $gjQuery() {
                this.loading = true;
                getSendRuleLog({
                    model: {
                        op: this.filter.opType,
                        userIdList: this.filter.userIdList,
                        ruleName: this.filter.ruleName,
                        createStartDate: this.filter.createDate ? convertToDate(this.filter.createDate[0]) : null,
                        createEndDate: this.filter.createDate ? convertToDate(this.filter.createDate[1]) : null,
                    },
                    ...this.queryPagination,
                    ...this.querySort
                }).complete(() => this.loading = false)
                    .then((data) => {
                        this.data = data.records;
                        this.pagination = this.getPagination(data);
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
